const ENDPOINT = new Map();

ENDPOINT.set('redirect', '/plugin/course/redirect');

export default ENDPOINT
